import React, { useState } from 'react'
import styles from './NavPanelMobile.module.sass'
import { MenuItemType } from '@utils/types'
import { Button, WLink } from '@components/atoms'
import useTrans from '@hooks/useTrans'
import { ArrowRight, ChevronDown, ChevronUp } from '@components/icons'
import NavCard from '../NavCard/NavCard'

interface Props {
  className?: string
  item?: MenuItemType
}

const NavPanelMobile = (props: Props) => {
  const { className = '', item = undefined } = props

  const [openIndexes, setOpenIndexes] = useState<Record<number, boolean>>({})

  const toggleDropdown = (index: number) => {
    setOpenIndexes((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  return item ? (
    <div className={`${styles.root} ${className}`}>
      {item.ctaLabel && item.url && (
        <div className={styles.buttons}>
          <Button
            label={item.name}
            href={item.url}
            newPage={item.blank}
            icon={<ArrowRight />}
            iconPos={'right'}
          />
        </div>
      )}
      {item.children?.length &&
        (item.key === 'prodotti' ? (
          item.children
            .filter((x) => !!x.children.length)
            .map((x) =>
              x.key === 'prodotti-evidenza' ? (
                <div className={styles.evidenza} key={x.pk}>
                  {x?.name && <div className={styles.evidenzaTitle}>{x.name}</div>}
                  <div className={styles.evidenzaMenu}>
                    {x.children.map((x) => (
                      <NavCard key={x.pk} item={x} />
                    ))}
                  </div>
                </div>
              ) : (
                <div className={styles.accordions} key={x.pk}>
                  {x.children.map((y, i1) => {
                    const isOpen = openIndexes[i1] || false
                    return (
                      <div key={i1} className={styles.list}>
                        <button
                          className={styles.dropdownButton}
                          onClick={(e) => {
                            e.stopPropagation()
                            toggleDropdown(i1)
                          }}
                        >
                          {y.name} {isOpen ? <ChevronUp /> : <ChevronDown />}
                        </button>
                        <ul
                          className={`${styles.dropdown} ${
                            isOpen ? styles['dropdown--open'] : ''
                          } ${y.style === 'colors' ? styles['dropdown--colors'] : ''}`}
                        >
                          {y.children.map((z, i2) => (
                            <li key={i2} className={styles.item}>
                              {y.style === 'colors' && (
                                <div
                                  className={styles.colorItem}
                                  style={{ backgroundColor: z.style }}
                                />
                              )}
                              <WLink href={z.url} newPage={z.blank}>
                                {z.name}
                              </WLink>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )
                  })}
                </div>
              )
            )
        ) : (
          <ul key={item.pk} className={styles.simplePanel}>
            {item.children.map((x, i) => (
              <li key={x.pk}>
                <WLink href={x.url} newPage={x.blank} className={styles.simplePanelTrigger}>
                  {x.name}
                </WLink>
              </li>
            ))}
          </ul>
        ))}
    </div>
  ) : (
    <></>
  )
}

export default NavPanelMobile
